import React from "react";
import { Card, Row, Col } from "antd";
import { SmileOutlined, SyncOutlined, MessageOutlined, FileSyncOutlined, FileTextOutlined } from "@ant-design/icons";
import "Common/global.scss";
import items from "./items";
import useDocumentsStore from "Hooks/AdminHooks/useDocumentStore";

// Icon logic
const getIconForItem = (title) => {
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes('recruit')) {
    if (lowerTitle.includes('spec')) return <SmileOutlined />;
    return <SyncOutlined />;
  } else if (lowerTitle.includes('offer')) {
    return <MessageOutlined />;
  } else if (lowerTitle.includes('performance') || lowerTitle.includes('report')) {
    return <FileSyncOutlined />;
  }
  return <FileTextOutlined />;
};

// 7 new card class names
const cardClasses = [
  "doc-card-1", 
  "doc-card-2", 
  "doc-card-3", 
  "doc-card-4", 
  "doc-card-5", 
  "doc-card-6", 
  "doc-card-7"
];

export default function CompanyDoc() {
  const { handleDocumentClick } = useDocumentsStore();

  return (
    <Card title="Company Documents" bordered={false} className="card-professional">
      <div className="document-cards-container">
        <Row gutter={[20, 20]} justify="center" align="middle">
          {items.map((item, index) => {
            // Cycle through the 7 card styles
            const cardClass = cardClasses[index % cardClasses.length];

            return (
              <Col xs={24} sm={12} md={8} lg={4.8} xl={4.8} key={item.id}>
                <div 
                  onClick={() => handleDocumentClick(item)} 
                  style={{ cursor: 'pointer' }}
                >
                  <Card className={`pro-green-card ${cardClass}`}>
                    <div className="pro-card-content">
                      <div className="card-icon">
                        {getIconForItem(item.title)}
                      </div>
                      <h3>{item.title}</h3>
                    </div>
                  </Card>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </Card>
  );
}